import React from 'react';
import { PlayCircle, ExternalLink } from 'lucide-react';
export function MediaSection() {
  return <section id="media" className="py-24 bg-[#0d1321] px-4 sm:px-6 lg:px-8" data-id="element-165" data-mp="3df3bnaf4w4ju">
      <div className="max-w-7xl mx-auto" data-id="element-166" data-mp="2zf2276kszosr">
        <div className="text-center mb-16" data-id="element-167" data-mp="2zgdddrgkvytw">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-168" data-mp="2zhemvrhy4d9i">
            Media & Appearances
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-cyan-400 to-blue-500 mx-auto rounded-full mb-6" data-id="element-169" data-mp="3s37klmodx1pf"></div>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto" data-id="element-170" data-mp="xpnkjqy8ccj">
            Watch Arthur discuss the future of financial infrastructure,
            post-quantum security, and ethical innovation.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-10 mb-12" data-id="element-171" data-mp="3nbg3e2r4c8by">
          {/* Podcast 1 */}
          <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-4 border border-white/10 shadow-sm" data-id="element-172" data-mp="ewfl20hoke1f">
            <div className="aspect-w-16 aspect-h-9 rounded-xl overflow-hidden bg-[#0B1120] relative mb-4" data-id="element-173" data-mp="jopis2p1eie9">
              <iframe src="https://www.youtube.com/embed/HP_rj8-P2AY" title="Arthur Miller Podcast Interview" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="w-full h-full absolute inset-0 rounded-xl" style={{
              minHeight: '300px'
            }} data-id="element-174" data-mp="uqx5nlhe26jn"></iframe>
            </div>
            <h3 className="text-xl font-bold text-white px-2" data-id="element-175" data-mp="18gqz6h3u9ezp">
              Architecting Trust at Scale
            </h3>
            <p className="text-slate-400 px-2 mt-2" data-id="element-176" data-mp="1mgs9en5ztyru">
              Deep dive into the foundational principles behind FiQIS and the
              future of banking.
            </p>
          </div>

          {/* Podcast 2 */}
          <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-4 border border-white/10 shadow-sm" data-id="element-177" data-mp="3oarid1vn841d">
            <div className="aspect-w-16 aspect-h-9 rounded-xl overflow-hidden bg-[#0B1120] relative mb-4" data-id="element-178" data-mp="1n6qeule12vau">
              <iframe src="https://www.youtube.com/embed/6zZkMNVoEW8" title="Arthur Miller Podcast Interview 2" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="w-full h-full absolute inset-0 rounded-xl" style={{
              minHeight: '300px'
            }} data-id="element-179" data-mp="1s5jtih51wscl"></iframe>
            </div>
            <h3 className="text-xl font-bold text-white px-2" data-id="element-180" data-mp="2b2ba2it7ktcy">
              The Post-Quantum Banking Era
            </h3>
            <p className="text-slate-400 px-2 mt-2" data-id="element-181" data-mp="2ku7gqi9d1rss">
              Discussing the critical need for advanced encryption in modern
              financial systems.
            </p>
          </div>
        </div>

        {/* Fox 5 Feature */}
        <div className="bg-gradient-to-br from-cyan-900/50 to-blue-900/50 backdrop-blur-md rounded-2xl p-8 md:p-12 text-center text-white relative overflow-hidden mb-16 border border-cyan-500/20 glow-cyan" data-id="element-182" data-mp="2tvypjvz76eqv">
          <div className="absolute top-0 right-0 w-64 h-64 bg-cyan-500/20 rounded-full blur-3xl opacity-50 transform translate-x-1/2 -translate-y-1/2" data-id="element-183" data-mp="e4ngmikmpvyq"></div>
          <div className="relative z-10" data-id="element-184" data-mp="48kc562b1l8m">
            <span className="inline-block px-4 py-1 bg-cyan-500/20 text-cyan-300 text-sm font-bold tracking-wider uppercase rounded-full mb-6 border border-cyan-500/30" data-id="element-185" data-mp="49lsnq23azxq">
              Television Feature
            </span>
            <h3 className="text-2xl md:text-3xl font-bold mb-4 text-white" data-id="element-186" data-mp="wz2e23ralgkg">
              Fox 5 San Diego: Innovator's Journey
            </h3>
            <p className="text-slate-300 text-lg max-w-2xl mx-auto mb-8" data-id="element-187" data-mp="n7ok0bi418yp">
              Watch the exclusive feature on how Arthur Miller's FiQIS is
              transforming finance and tackling the hidden costs of legacy
              banking infrastructure.
            </p>
            <a href="https://fox5sandiego.com/fox-5-partners/innovators-journey/arthur-millers-fiqis-is-transforming-finance/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-8 py-3.5 bg-cyan-400 text-black font-bold rounded-lg hover:bg-cyan-300 transition-colors shadow-lg" data-id="element-188" data-mp="10dsskzrd4u0j">
              <PlayCircle className="h-5 w-5" data-id="element-189" data-mp="1j426h6wiia82" />
              Watch Feature on Fox 5
            </a>
          </div>
        </div>

        {/* Additional Podcast Appearances */}
        <div className="mt-16" data-id="element-190" data-mp="1o2c0he6i34s3">
          <div className="text-center mb-12" data-id="element-191" data-mp="19eimfxx2cabm">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-3" data-id="element-192" data-mp="19dftlkg6jxt2">
              Additional Podcast Appearances
            </h3>
            <p className="text-slate-400" data-id="element-193" data-mp="1eazdazvnd2se">
              More conversations on fintech innovation, leadership, and the
              future of banking.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-194" data-mp="26vppl2nj8gzs">
            <a href="https://youtube.com/watch?v=HP_rj8-P2AY" target="_blank" rel="noopener noreferrer" className="group bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10 hover:border-cyan-500/30 hover:bg-white/10 transition-all" data-id="element-195" data-mp="3riqrzz026puj">
              <div className="flex items-start justify-between mb-3" data-id="element-196" data-mp="65vpkpe9he6">
                <span className="text-sm font-bold text-cyan-400 uppercase tracking-wider" data-id="element-197" data-mp="38m7ekxi82fs6">
                  YouTube
                </span>
                <ExternalLink className="h-4 w-4 text-slate-400 group-hover:text-cyan-400 transition-colors" data-id="element-198" data-mp="33o5uqacz2cfn" />
              </div>
              <h4 className="text-lg font-bold text-white group-hover:text-cyan-300 transition-colors mb-2" data-id="element-199" data-mp="3cm9jdfj97pbo">
                Architecting Trust at Scale
              </h4>
              <p className="text-sm text-slate-400" data-id="element-200" data-mp="wxg81eyzpnnv">
                Deep dive into the foundational principles behind FiQIS and the
                future of banking.
              </p>
            </a>

            <a href="https://youtube.com/watch?v=6zZkMNVoEW8" target="_blank" rel="noopener noreferrer" className="group bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10 hover:border-cyan-500/30 hover:bg-white/10 transition-all" data-id="element-201" data-mp="3lqut3lmmiyb7">
              <div className="flex items-start justify-between mb-3" data-id="element-202" data-mp="32yajbmim9jx9">
                <span className="text-sm font-bold text-cyan-400 uppercase tracking-wider" data-id="element-203" data-mp="32vxsejuvrz82">
                  YouTube
                </span>
                <ExternalLink className="h-4 w-4 text-slate-400 group-hover:text-cyan-400 transition-colors" data-id="element-204" data-mp="3by72x9q5fslg" />
              </div>
              <h4 className="text-lg font-bold text-white group-hover:text-cyan-300 transition-colors mb-2" data-id="element-205" data-mp="3gq73n4e1mpj3">
                The Post-Quantum Banking Era
              </h4>
              <p className="text-sm text-slate-400" data-id="element-206" data-mp="2o8cpapy0a005">
                Discussing the critical need for advanced encryption in modern
                financial systems.
              </p>
            </a>
          </div>
        </div>
      </div>
    </section>;
}